import { render, staticRenderFns } from "./Swatches.vue?vue&type=template&id=11f3da6f&scoped=true"
import script from "./Swatches.vue?vue&type=script&lang=js"
export * from "./Swatches.vue?vue&type=script&lang=js"
import style0 from "./Swatches.vue?vue&type=style&index=0&id=11f3da6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f3da6f",
  null
  
)

export default component.exports